import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {IntroWizardServiceProvider} from "../intro-wizard-service/intro-wizard-service";
import {User, UserStateProvider} from "../user-state/user-state";
import {InitWizardProvider} from "../init-wizard/init-wizard";

/*
  Generated class for the ApiInitProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiInitProvider {

  constructor(public api: ApiProvider, public userState: UserStateProvider) {
  }

  finishInitialization(initWizard: InitWizardProvider) {
    var me = this;
    return new Promise((resolve, reject) => {
      let payload: any = {};
      payload.firstName = this.userState.user.firstName;
      payload.program = initWizard;
      this.api.callPut<User>('/users/'+this.userState.user.id, payload).subscribe(success => {
        console.log(success);
        me.userState.user = success;
        resolve();
      }, err => {
        console.log(err);
        reject();
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-init/api-init.ts